import $store from '@/store'
import { getMappingList } from '@/api/sysManage/baseConfig/mappingManage'
import { SENDING_THAILAND } from '@/class/cargo/model/parameters/SystemConstants'
import { AfrAddress } from '@/class/model/booking/AfrAddress'
import { exportThailand } from '@/api/seaExport/cargoDoc'

export default async function(cargoDocs, lob) {
  const firstDoc = cargoDocs[0]
  const office = $store.getters.currentOffice
  let registrationID = ''
  const unitCodeMap = new Map()
  await getMappingList({ sendingPlatform: SENDING_THAILAND.code, officeId: office.officeId }).then((res) => {
    for (const item of res.data) {
      if (item.type === 'OFFICE_CODE') {
        if (item.sourceValue === office.code) {
          registrationID = item.targetValue
        }
      } else if (item.type === 'AMS_PK') {
        unitCodeMap.set(item.sourceValue, item.targetValue)
      }
    }
  })
  let reminderContent = ''
  const firstReminderLines = []
  if (!firstDoc.shipAgentTaxNo) {
    firstReminderLines.push('"Ship Agent Tax No" is Empty')
  } else if (firstDoc.shipAgentTaxNo.length > 6) {
    firstReminderLines.push('"Ship Agent Tax No" is too long')
  }
  if (!office.taxAccount) {
    firstReminderLines.push('Container Operator Tax Number is Empty. Please go to Branch Profile  and input Taxpayer ID.')
  }
  if (firstDoc.vesselCode.length > 35) {
    firstReminderLines.push('"Call Sign is" too long')
  }
  if (firstDoc.voyageFlight.length > 17) {
    firstReminderLines.push('"Voyage" is too long')
  }
  if (!registrationID) {
    firstReminderLines.push('Sender Registration ID is Empty. Please go to Mapping Mangement and create mapping between 分公司代码 and Sender Registration ID.')
  }
  for (let i = 0; i < cargoDocs.length; ++i) {
    const doc = cargoDocs[i]
    const reminderLines = [...firstReminderLines]
    if (!doc.hblNbr2) {
      reminderLines.push('"HB/L NO" is Empty')
    } else if (doc.hblNbr2.length > 35) {
      reminderLines.push('"HB/L NO" is too long')
    }
    if (!doc.loadingPort) {
      reminderLines.push('"Place of Loading" is Empty')
    } else if (doc.loadingPort.length > 5) {
      reminderLines.push('"Place of Loading" is too long')
    }
    if (!doc.dischargingPort) {
      reminderLines.push('"Place of Discharge" is Empty')
    } else if (doc.dischargingPort.length > 5) {
      reminderLines.push('"Place of Discharge" is too long')
    }
    if (doc.shedNumber && doc.shedNumber.length > 4) {
      reminderLines.push('"Shed Number/Release Port" is too long')
    }
    let afrAddress = null
    if (doc.afrAddress && doc.afrAddress.length > 0) {
      afrAddress = doc.afrAddress[0]
    } else {
      afrAddress = new AfrAddress().fillDefaultValue().getData()
    }
    if (afrAddress.shipperLine1.length > 70) {
      reminderLines.push('"Shipper Name" is too long')
    }
    let shipperAddress = afrAddress.shipperLine1
    if (shipperAddress) {
      shipperAddress += '\n'
      shipperAddress += afrAddress.shipperLine2
      shipperAddress += afrAddress.shipperLine3
      shipperAddress += afrAddress.shipperLine4
      shipperAddress += afrAddress.shipperLine5
      shipperAddress += afrAddress.shipperLine6
    }
    if (!shipperAddress) {
      reminderLines.push('"Shipper Name and Address" is Empty')
    } else if (shipperAddress.length > 512) {
      reminderLines.push('"Shipper Name and Address" is too long')
    }
    if (afrAddress.shipperCountry && afrAddress.shipperCountry.length > 2) {
      reminderLines.push('"Shipper Country" is too long')
    }
    if (afrAddress.consigneeLine1.length > 70) {
      reminderLines.push('"Consignee Name" is too long')
    }
    let consigneeAddress = afrAddress.consigneeLine1
    if (consigneeAddress) {
      consigneeAddress += '\n'
      consigneeAddress += afrAddress.consigneeLine2
      consigneeAddress += afrAddress.consigneeLine3
      consigneeAddress += afrAddress.consigneeLine4
      consigneeAddress += afrAddress.consigneeLine5
      consigneeAddress += afrAddress.consigneeLine6
    }
    if (!consigneeAddress) {
      reminderLines.push('"Consignee Name and Address" is Empty')
    } else if (consigneeAddress.length > 512) {
      reminderLines.push('"Consignee Name and Address" is too long')
    }
    if (afrAddress.consigneeCountry && afrAddress.consigneeCountry.length > 2) {
      reminderLines.push('"Consignee Country" is too long')
    }
    if (afrAddress.notifyLine1.length > 70) {
      reminderLines.push('"Notify Party Name" is too long')
    }
    let notifyAddress = afrAddress.notifyLine1
    if (notifyAddress) {
      notifyAddress += '\n'
      notifyAddress += afrAddress.notifyLine2
      notifyAddress += afrAddress.notifyLine3
      notifyAddress += afrAddress.notifyLine4
      notifyAddress += afrAddress.notifyLine5
      notifyAddress += afrAddress.notifyLine6
    }
    if (!notifyAddress) {
      reminderLines.push('"Notify Party Name and Address" is Empty')
    } else if (notifyAddress.length > 512) {
      reminderLines.push('"Notify Party Name and Address" is too long')
    }
    if (afrAddress.notifyCountry && afrAddress.notifyCountry.length > 2) {
      reminderLines.push('"Notify Party Country" is too long')
    }
    if (!doc.weight) {
      reminderLines.push('"Gross Weight" is Empty')
    }
    if (!doc.quantity) {
      reminderLines.push('"Quantity" is Empty')
    }
    if (doc.packing) {
      const unitCode = unitCodeMap.get(doc.packing)
      if (!unitCode) {
        reminderLines.push(`"${doc.packing}" cannot find mapping. Please go to Mapping Mangement and create mapping between 反恐舱单包装代码  and Thai's Package Code.`)
      }
    } else {
      reminderLines.push('"Unit Type" is Empty')
    }
    if (!doc.remarks) {
      reminderLines.push('"Remark" is Empty')
    } else if (doc.remarks.length > 512) {
      reminderLines.push('"Remark" is too long')
    }
    if (!doc.cargoEnglishName) {
      reminderLines.push('"Description of Goods" is Empty')
    } else if (doc.cargoEnglishName.length > 512) {
      reminderLines.push('"Description of Goods" is too long')
    }
    if (!doc.docCargoType) {
      reminderLines.push('"Cargo Type" is Empty')
    }
    if (doc.undgNumber && doc.undgNumber.length > 4) {
      reminderLines.push('"UNDG Number" is too long')
    }
    if (doc.imoClass && doc.imoClass.length > 4) {
      reminderLines.push('"IMO Class" is too long')
    }
    if (doc.ediContainer) {
      for (let j = 0; j < doc.ediContainer.length; ++j) {
        const container = doc.ediContainer[j]
        if (!container.containerNo) {
          reminderLines.push('"Container No" is Empty')
        } else if (container.containerNo.length > 17) {
          reminderLines.push('"Container No" is too long')
        }
        if (!container.containerStatus) {
          reminderLines.push('"Container Status" is Empty')
        } else if (container.containerStatus.length > 3) {
          reminderLines.push('"Container Status" is too long')
        }
        if (!container.goodsCargoType) {
          reminderLines.push('"Goods Cargo Type" is Empty')
        } else if (container.goodsCargoType.length > 1) {
          reminderLines.push('"Goods Cargo Type" is too long')
        }
        if (container.undgNumber && container.undgNumber.length > 4) {
          reminderLines.push('"UNDG Number" is too long')
        }
        if (container.imoClass && container.imoClass.length > 4) {
          reminderLines.push('"IMO Class" is too long')
        }
      }
    }
    const newReminderLines = []
    const reminderLineSet = new Set()
    for (const line of reminderLines) {
      if (reminderLineSet.has(line)) {
        continue
      }
      newReminderLines.push(line)
    }
    if (newReminderLines.length > 0) {
      if (reminderContent) {
        reminderContent += '\n\n'
      }
      reminderContent += 'HBL ' + doc.hblNbr2
      for (let i = 0; i < newReminderLines.length; ++i) {
        reminderContent += `\n        ${i + 1}.${newReminderLines[i]}`
      }
    }
  }
  const content = await exportThailand({ jobKey: firstDoc.jobUuid, lob, branchId: $store.getters.currentOfficeId }).then(res => res.data)
  return {
    reminderContent: reminderContent,
    content: content
  }
}
